const sanitizeData = ({ data, spending, ...restProps }) => {
  const balanceBreakup = { spends: 0, earns: 0 }

  const expenses = spending.reduce((acc, { date, ...rest }) => {
    const name = Object.keys(rest)[0]
    const amount = rest[name]
    acc.push({ date, name, amount })

    return acc
  }, [])

  // Asssumption: The order of the items would be spends -> earns, and one item would account for a single day
  const spendChartData = data?.datasets[0]?.data?.map((day, index) => {
    balanceBreakup.spends += day
    balanceBreakup.earns += data.datasets[1].data[index]

    return {
      name: index + 1,
      spend: day,
      earn: data.datasets[1].data[index]
    }
  })

  const chartMetaData = data?.datasets?.map((dataset) => ({
    borderColor: dataset.borderColor
  }))

  return { expenses, spendChartData, balanceBreakup, chartMetaData, ...restProps }
}

export default sanitizeData
